<div class="expanded-search-step-content">
  <sg-text class="expanded-search-step-title" color="decorative-text-01" variant="sg-p4-big-paragraph">Outbound</sg-text>
  <sg-text class="expanded-search-step-description" color="text-secondary" variant="sg-p3-standard">
    As a first step, let's check if the file was successfully processed and sent out to client:
  </sg-text>
  <form pbl-nform #expandedSearchForm [model]="inspectorFormModel" [filter]="relevantFields" filterMode="include" class="expanded-search-step-form"></form>
  <sg-button
    (click)="inspectOutboundFolderClicked()"
    class="expanded-search-step-start-investigation-button"
    size="medium"
    text="Inspect outbound folder"
    icon="search"
    variant="primary"></sg-button>
</div>
